<template>
  <path
    d="M20 7.00024H4C2.9 7.00024 2 6.10024 2 5.00024V4.00024C2 2.90024 2.9 2.00024 4 2.00024H20C21.1 2.00024 22 2.90024 22 4.00024V5.00024C22 6.10024 21.1 7.00024 20 7.00024ZM20 9.50024H4C2.9 9.50024 2 10.4002 2 11.5002V12.5002C2 13.6002 2.9 14.5002 4 14.5002H20C21.1 14.5002 22 13.6002 22 12.5002V11.5002C22 10.4002 21.1 9.50024 20 9.50024ZM20 17.0002H4C2.9 17.0002 2 17.9002 2 19.0002V20.0002C2 21.1002 2.9 22.0002 4 22.0002H20C21.1 22.0002 22 21.1002 22 20.0002V19.0002C22 17.9002 21.1 17.0002 20 17.0002Z"
  />
</template>
